angular
  .module('middlewares.isLoggedIn', [
    'resources.User'
  ])
  .service('isLoggedIn', ["User", "$state", function (User, $state) {

    return function(next) {
      User.current(function (user) {
        if (user && user.is_active) {
          return next();
        }

        return $state.go('unauthorized');
      });
    };

  }]);



// WEBPACK FOOTER //
// ./client/src/common/middlewares/isLoggedIn.js